import { concat } from '../../helpers/common'
import { UpdateUserPayload, UpdateUserSuccessPayload, UpdateUserFailurePayload } from '../types/user'

const MODULE_NAME = 'USER/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION

export const UPDATE_USER = concat(MODULE_NAME, 'UPDATE_USER')
export const UPDATE_USER_SUCCESS = concat(MODULE_NAME, 'UPDATE_USER_SUCCESS')
export const UPDATE_USER_FAILURE = concat(MODULE_NAME, 'UPDATE_USER_FAILURE')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

export function updateUser(userData: object, userId: number): UpdateUserPayload {
  return { type: UPDATE_USER, userData, userId }
}

export function updateUserSuccess(userData: object): UpdateUserSuccessPayload {
  return { type: UPDATE_USER_SUCCESS, userData }
}

export function updateUserFailure(error: object): UpdateUserFailurePayload {
  return { type: UPDATE_USER_FAILURE, error }
}
